module.exports = __webpack_public_path__ + "img/logo.a84ba0de.png";